import { LucideProps } from 'lucide-react';

import { icons, Icon as IconType } from './icons';

export interface DynamicIconProps extends LucideProps {
  icon?: IconType;
}

export const DynamicIcon = ({ icon, ...rest }: DynamicIconProps) => {
  const Icon = icon && icons[icon];

  if (!Icon) {
    return null;
  }

  return <Icon {...rest} />;
};

export type { Icon } from './icons';
